import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n/config";
import { initSentry } from "./lib/sentry";
import "./styles/tokens.css";
import "./styles/globals.css";

// Fire Sentry init early but don't block first paint on it. The dynamic
// import inside initSentry means the SDK isn't even fetched when DSN is
// unset — so this line is free in the no-Sentry path.
void initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
